import { render, staticRenderFns } from "./ImageLoginPage.vue?vue&type=template&id=79ed73c8&"
import script from "./ImageLoginPage.vue?vue&type=script&lang=js&"
export * from "./ImageLoginPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports